import { Pipe, PipeTransform } from '@angular/core';
import { AssetVersionDto, AssetVideoTypeDataDto } from '@picflow/types';

@Pipe({
  name: 'videoTimePercentToString',
  standalone: true,
})
export class VideoTimePercentToStringPipe implements PipeTransform {
  transform(fraction: number | [number, number], assetVersion: AssetVersionDto): string {
    if (!assetVersion) return;

    if (Array.isArray(fraction)) {
      fraction = fraction[0];
    }

    const timeInSeconds = (assetVersion.data as AssetVideoTypeDataDto).duration * fraction;

    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}
